var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDLogoColorFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.4735 16.5834C34.6131 17.723 35.7527 18.8626 35.7527 18.8626C37.2878 17.3276 37.2956 15.8003 35.7761 14.2808C34.6364 13.1411 33.8767 12.3814 33.8806 11.6177C31.9617 13.5366 31.954 15.0638 33.4735 16.5834Z",
    fill: "url(#paint0_linear_4474_33285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M33.8068 26.1272C33.8107 25.3635 34.5782 24.596 35.7295 23.4447C37.2646 21.9096 37.2724 20.3823 35.7529 18.8628C35.7529 18.8628 34.6016 20.0141 33.4503 21.1654C31.9152 22.7005 31.9074 24.2278 33.8068 26.1272Z",
    fill: "url(#paint1_linear_4474_33285)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5233 3.2605C24.7596 3.26439 23.9999 2.50463 22.8602 1.36499C21.3407 -0.154524 19.8134 -0.146748 18.2784 1.38832C18.2784 1.38832 19.418 2.52796 20.5576 3.66759C22.0772 5.18711 23.6045 5.17933 25.5233 3.2605Z",
    fill: "url(#paint2_linear_4474_33285)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M15.9759 3.69103C17.1272 2.53973 18.2785 1.38843 18.2785 1.38843C16.759 -0.131088 15.2317 -0.123311 13.6966 1.41176C12.5453 2.56306 11.7778 3.33059 11.0141 3.33448C12.9135 5.23387 14.4408 5.2261 15.9759 3.69103Z",
    fill: "url(#paint3_linear_4474_33285)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M33.8807 11.6178C35.7995 9.69893 35.8073 8.17164 33.528 5.89237L31.2487 3.61309C28.9695 1.33382 27.4422 1.34159 25.5233 3.26043C26.287 3.25654 27.4432 4.37955 28.9461 5.91569L31.2254 8.19497C32.7287 9.73069 33.8846 10.8541 33.8807 11.6178Z",
    fill: "url(#paint4_linear_4474_33285)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.014 3.33447C9.11458 1.43508 7.58729 1.44285 5.28469 3.74546L2.98209 6.04806C0.679487 8.35066 0.671711 9.87795 2.5711 11.7773C2.57499 11.0137 3.70983 9.84594 5.26136 8.32733L7.56396 6.02473C9.11507 4.5057 10.2503 3.33836 11.014 3.33447Z",
    fill: "url(#paint5_linear_4474_33285)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.364 34.5701C27.2634 36.4695 28.7907 36.4617 31.0933 34.1591L33.3959 31.8565C35.6985 29.5539 35.7063 28.0266 33.8069 26.1272C33.803 26.8909 32.6681 28.0586 31.1166 29.5772L28.814 31.8798C27.2629 33.3989 26.1276 34.5662 25.364 34.5701Z",
    fill: "url(#paint6_linear_4474_33285)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 10.8036H17.0838C18.9605 10.8036 20.598 11.1649 21.9963 11.8837C23.3946 12.6061 24.4795 13.6397 25.2477 14.988C26.0159 16.3363 26.4 17.9099 26.4 19.7124C26.4 22.6987 25.5678 24.9626 23.9 26.4969C22.2355 28.0347 19.9444 28.8 17.0333 28.8H10.8V10.8V10.8036ZM17.3971 24.3224C18.6438 24.3224 19.6007 23.9111 20.2712 23.085C20.9417 22.2624 21.2786 21.1358 21.2786 19.7124C21.2786 18.4428 20.9383 17.3878 20.2611 16.5437C19.5838 15.6997 18.6505 15.2813 17.4713 15.2813H15.8203V24.3188H17.3971V24.3224Z",
    fill: "url(#paint7_linear_4474_33285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4474_33285",
    x1: 36.1601,
    y1: 13.8972,
    x2: 33.4737,
    y2: 16.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4474_33285",
    x1: 37.0826,
    y1: 20.1925,
    x2: 32.4774,
    y2: 24.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4474_33285",
    x1: 23.2443,
    y1: 0.981474,
    x2: 20.5579,
    y2: 3.66784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4474_33285",
    x1: 16.949,
    y1: 0.058997,
    x2: 12.3438,
    y2: 4.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4474_33285",
    x1: 32.3888,
    y1: 4.75318,
    x2: 29.7025,
    y2: 7.43955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4474_33285",
    x1: 9.68455,
    y1: 2.00504,
    x2: 1.24167,
    y2: 10.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4474_33285",
    x1: 35.1366,
    y1: 27.4569,
    x2: 26.6937,
    y2: 35.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4474_33285",
    x1: 10.8,
    y1: 19.7991,
    x2: 26.4,
    y2: 19.7991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogoColorFlat);
export default __webpack_public_path__ + "static/media/d-logo-color-flat.2a94909e61aae65efad1c3628dd116b2.svg";
export { ForwardRef as ReactComponent };